<template>
  <div class="historic-personal-doctors-network-error__container">
    <div class="mb-4">{{ $t('personal_doctor.network_error') }}</div>
    <div>
      <v-btn depressed color="primary" :disabled="loading" @click="retry">
        <v-icon left>
          mdi-refresh
        </v-icon>
        {{ $t('personal_doctor.retry') }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: ['retry', 'loading'],
};
</script>

<style>
.historic-personal-doctors-network-error__container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
